import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageSelectService } from '../../service/image-select.service';
import { Content } from '../../types/ws-select-image';

@Component({
	selector: 'ws-img-select',
	templateUrl: './image-select.component.html',
	styleUrls: ['./image-select.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ImageSelectComponent implements OnInit {
	@ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
	@Output() imageSelected = new EventEmitter<string>();

	constructor(private dialog: MatDialog, private imageSelectService: ImageSelectService) {}

	ngOnInit(): void {}

	openDialog() {
		this.imageSelectService.fetchImages();

		this.dialog.open(this.dialogTemplate, {
			width: '800px',
			panelClass: 'dialog-container',
		});
	}

	get images(): Content[] {
		return this.imageSelectService.imageObjects;
	}

	selectImage(imageId: string) {
		this.imageSelected.emit(imageId);
		this.dialog.closeAll();
	}

	/*closeDialog() {
    this.dialog.close()
  }*/
}
